module.exports = __webpack_public_path__ + "static/media/crm_img3.9d63a7dc.jpg";